module.exports = __webpack_public_path__ + "static/media/happy_cloud.978c3f05.svg";